module.exports = __webpack_public_path__ + "assets/celianggongju.104e4215.svg";